import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const nonAuthGuard: CanActivateFn = (
  route,
  state
): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.currentUser$.pipe(
    take(1),
    map((user) => {
      if (!authService.isLoggedIn()) {
        return true;
      }

      if (user?.is_admin === true) {
        router.navigate(['/admin/dashboard'], { replaceUrl: true });
        return false;
      }

      router.navigate(['/home'], { replaceUrl: true });
      return false;
    })
  );
};
